import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  textFieldHelperText: {
    position: 'relative',

    '& .MuiFormHelperText-root': {
      zIndex: 122,
    },

    '& .Mui-error': {
      color: theme.palette.error.main,
    },

    '& .MuiTypography-colorTextSecondary': {
      color: theme.palette.common.black,
    },
  },
}));
